import BaseObject from "./baseobject";
import SceneObject from "./sceneobject"
import Stage from "../stage/stage";
import Camera from "./camera";
import CollisionService from "../collision/collision_service";

export default class Scene extends BaseObject
{
    sceneobjects:SceneObject[];
    
    constructor(key:string)
    {
        super(key);
        this.sceneobjects = [];
    }

    add(sceneobject:SceneObject)
    {
        this.sceneobjects.push(sceneobject);
    }

    query_number(key: string): number | null
    {
        return 0;
    }

    query_string(key: string): string
    {
        return "";

    }

    query_bool(key: string): boolean
    {
        return false;

    }

    set_string(key:string,str:string):void
    {

    }
    
    tick(delta_time: number)
    {
        for (const obj of this.sceneobjects) 
        {
             obj.tick(delta_time);
        }
    }


    prepare(device: GPUDevice) {}
    

    internal_prepare(device: GPUDevice, camera:Camera) 
    {
        const stage = Stage.instance();
        const canvas = stage.render_service.canvas;
        if (canvas)
        {
             camera.set_aspect(canvas.width / canvas.height);
        }

        camera.update_matrices();
        Stage.instance().collision_service.prepare(device,camera);
        Stage.instance().render_service.set_camera(camera);

    }
  

    async activate(canvas:HTMLCanvasElement)
    {
        const stage = Stage.instance();
        const render = stage.render_service;
        render.reset(canvas);

        for (const obj of this.sceneobjects) 
        {
            render.add(obj);
        }

        render.build();
        stage.start();   
    }
    deactivate()
    {
        const stage = Stage.instance();
         stage.stop();
         stage.render_service.clear();
     }

    ui_message(cmd: string, msg: string) 
    {
        for (const obj of this.sceneobjects)
        {
            obj.ui_message(cmd, msg);
        }
  }
   
    
}